import { Database, ref, update } from 'firebase/database';

export const teachersUpdate = async (
	database: Database,
	previousTeacherName: string,
	nextTeacherName: string,
	teacher: { name?: string; subjects?: string[]; [key: string]: unknown }
): Promise<void> => {
	const currentName = previousTeacherName.trim();
	const nextName = nextTeacherName.trim();

	if (!currentName || !nextName || currentName === nextName) {
		return;
	}

	return update(ref(database), {
		[`teachers/${currentName}`]: null,
		[`teachers/${nextName}`]: {
			...teacher,
			name: nextName,
			subjects: teacher.subjects ?? [],
		},
	});
};
